import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './app'

import 'babel-polyfill'
import '@notainc/key-focus-visible'
import '@planningcenter/tapestry/index.css'

const container = document.getElementById('root')

createRoot(container).render(<App tab="home" />)
